/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState } from 'react'
import ThreeDotsLoader from '../../../Components/LoadingDots';
import Spinner from '../../../Components/Spinner';
import { uploadFileToS3 } from '../../../redux/helper/s3Upload';
import { creatUUId } from '../../../redux/helper/CreateUUID';
import { distributorService } from '../../../service/distributor.service';

const RequestToReturnModal = ({ returnRequestModal, setReturnRequestModal, viewInvoiceDetails, selectedInvoiceNumber, requestData, setRequestData, handleReturnToRequest, ProceedreturnRequest, threeDotsLoader, setThreeDotsLoader }) => {
    const [spinner, setspinner] = useState(false)
    // const ReactS3Client = new S3(Uploadconfig);

    const InputChange = (e, index) => {
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '') {
            setRequestData((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            setRequestData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
    };

    const handleUploadedFiles = (val, key) => {
        // setRender(true);
        const data = { ...requestData };
        const idx = data[key].indexOf(val)
        if (idx > -1) {
            data[key].splice(idx, 1)
        } else {
            data[key].push(val)
        }
        // data.attached_file = [val];
        setRequestData(data);
        setspinner(false)
    };

    const handleUploadDoc = async (e, key) => {
        const files = e.target.files;
        setspinner(true);
    
        if (!files || files.length === 0) {
            setspinner(false);
            return;
        }
        try {
            let nameKey = `eub/${creatUUId()}/${files[0].name}`
            const fileUrl = await distributorService.uploadImages(nameKey, files[0])
            const keyPath = fileUrl.split('.com/')[1]; // get the path for storing in backend
            await distributorService.getSignedUrl(keyPath,'get')
            handleUploadedFiles(keyPath, key);
        } catch (err) {
            console.error("S3 Upload Error:", err);
            handleErrorMessage("File upload failed");
        } finally {
            setspinner(false);
        }
    };

    return (
        <>
            <div className={`modal ${returnRequestModal ? 'show' : 'hidden '} fade fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="Return-Order-Request" tabIndex="-1" aria-labelledby="addDocumnetation" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered relative lg:max-w-[443px] lg:min-w-[443px] w-full px-3 mx-auto pointer-events-none" style={{ margin: 'auto' }}>
                    <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white border border-[#707070] bg-clip-padding rounded-md outline-none text-current md:px-[30px] sm:px-4 px-3 sm:pt-[32px] pt-4 pb-5">
                        <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                            <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                                Return Order Request
                            </h5>
                            <button onClick={() => setReturnRequestModal(false)} type="button" className="absolute top-0 right-0" data-bs-dismiss="modal" aria-label="Close">
                                <img src="/images/Icon-ionic-ios-close.svg" alt="icon" />
                            </button>
                        </div>
                        <div>
                            <div className="mt-3 flex items-center">
                                <div>

                                    {/* <img src={handleImage(OrderDetails.distributor_info?.profile_image_url)} alt="icon" loading="lazy" decoding="async" style={{ borderRadius: '50%', height: '55px', width: '55px' }} /> */}

                                </div>
                                <div className="pl-3.5">
                                    {/* {(OrderDetails.distributor_info.FIRST_NAME !== null || OrderDetails.distributor_info.LAST_NAME !== null)
                                        ? (
                                            <p className="text-base font-semibold text-[#303030]">
                                                {OrderDetails.distributor_info.FIRST_NAME}
                                                {' '}
                                                {OrderDetails.distributor_info.LAST_NAME}
                                            </p>
                                        )
                                        : (
                                            <p className="text-base font-semibold text-[#303030]">
                                                {OrderDetails.distributor_info.PARTY_NAME}

                                            </p>
                                        )}

                                    <p className="text-xs13 font-normal text-[#555259]">{OrderDetails.distributor_id}</p> */}
                                </div>
                            </div>
                            <div>
                                <p classNamefirst="font-semibold text-xs text-[#777777]">Invoice Number</p>
                                <p className="font-normal text-[#090406] sm:text-xs16 text-base">{selectedInvoiceNumber.TRX_NUMBER}</p>
                            </div>
                        </div>
                        <div className="modal-body pt-[22px]">
                            <div className="relative">
                                <label htmlFor="return_request_note" className="text-base font-semibold text-[#555259]"></label>
                                <textarea
                                    name="enterMoremessage"
                                    id="return_request_note"
                                    className="w-full h-[108px] resize-none px-[13px] py-[14px] border border-[#707070] rounded-lg mt-3 sm:text-base text-xs6 font-normal text-[#000000] placeholder:text-base placeholder:text-[#808285] placeholder:font-normal outline-none custom-scrollbar"
                                    placeholder="Enter Reason for Return"
                                    maxLength={500}
                                    onChange={(e) => {
                                        InputChange(e);
                                        // setsubmitSelected(false);
                                    }}
                                >
                                </textarea>
                                <div className="flex justify-end items-center absolute bottom-[3px] right-5">
                                    <p className="px-1 bg-[#FFFFFF] text-xs13 font-normal text-[#808285] ml-1 cursor-pointer upload">500 words</p>
                                </div>
                            </div>
                            <div className="relative mt-2.5 mb-1 ">
                                <input
                                    type="file"
                                    id='file'
                                    className="opacity-0 absolute top-0 left-0 cursor-pointer w-20 h-5"
                                    onChange={(e) => handleUploadDoc(e, 'attached_file')}
                                />
                                <label htmlFor="file" className="text-sm font-semibold text-[#808285] cursor-pointer">+ Attach file  (Optional) <span>{spinner && <Spinner />}</span></label>
                            </div>
                            {/* {requestData.attached_file.length > 0  && requestData.attached_file.map((item) => (
                                pppppp
                            ))} */}
                            {/* <!-- showing uploaded file --> */}
                            <div className="mt-3.5 flex items-center file-uploaded">
                                {requestData.attached_file.length > 0 && requestData.attached_file.map((item) => (
                                    <>
                                        <div className="flex items-center">
                                            <img src="/images/doc-black.svg" alt="uploaded-img" />
                                            <p className="ml-2.5 font-semibold text-sm text-black">{item.split('/').at(-1)}</p>
                                        </div>
                                        <span className="ml-2.5">
                                            <img src="/images/circle-close.svg" alt="close-icon" className="cursor-pointer" onClick={() => handleUploadedFiles(item, 'attached_file')} />
                                        </span>
                                    </>
                                ))}


                            </div>
                            <div className="pt-[22px] flex justify-center">
                                <button
                                    type="button"
                                    className="w-full sm:w-[306px] sm:py-3.5 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold return-order text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    data-bs-toggle="modal"
                                    data-bs-target="#orderPlaced"
                                    onClick={() => ProceedreturnRequest()}
                                    disabled={threeDotsLoader}
                                >
                                    {threeDotsLoader ? <div className='ml-[138px]'><ThreeDotsLoader /> </div> : 'Return Order'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default RequestToReturnModal